"use client";

import React from "react";
import { Button, Flex, Typography } from "antd/lib";
import { useTranslation } from "react-i18next";

const { Title, Paragraph } = Typography;

const StorageBlockedNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Flex gap={24} vertical justify="center" align="center" style={{ padding: 24 }}>
      <Title level={2}>{t("common.messages.storageBlockedTitle")}</Title>

      <Paragraph style={{ textAlign: "center", maxWidth: 560 }}>{t("common.messages.storageBlocked")}</Paragraph>

      <Button type="primary" onClick={() => window.location.reload()}>
        {t("common.actions.reload")}
      </Button>
    </Flex>
  );
};

export default StorageBlockedNotice;
